export default "__VITE_ASSET__008eb12b__"